import { Form, Select } from "antd";
import { TextService } from "../../Services/TextService";


export const BookySelectDropDown = (props: any) => {
    const GetText = TextService.GetText;

    const handleChange = (value: { value: string; label: React.ReactNode }) => {
        props.handleChange(value);
    };

    const rules: any = [];
    if (props.req) {
        rules.push({
            required: true,
            message: props.requiredMessage || GetText("EditMember_Mandatory"),
        });
    }

    return (

        <Form.Item label={props.label} name={props.name} rules={rules}
        >
            <Select
                placeholder={props.placeholder}
                style={props.style}
                allowClear={props.allowClear}
                options={props.options}
                value={props.value}
                onChange={handleChange}
            />
        </Form.Item>
    );

}